import { useTranslation } from "react-i18next";

const DeleteConfirmModal = ({ confirmDeleteId, onCancel, onConfirm }) => {
    const { t } = useTranslation();
    if (!confirmDeleteId) return null;

    return (
        <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 backdrop-blur-sm px-4">
            <div className="w-full max-w-sm rounded-[20px] border border-white/70 bg-white/85 p-5 shadow-[0_24px_80px_rgba(15,23,42,0.25)]">
                <div className="text-base font-semibold text-slate-900">
                    {t('aura delete title')}
                </div>
                <div className="mt-2 text-sm text-slate-600">
                    {t('aura delete description')}
                </div>
                <div className="mt-4 flex items-center justify-end gap-2">
                    <button
                        type="button"
                        className="rounded-full border border-white/70 bg-white/70 px-4 py-1.5 text-xs text-slate-700 shadow-[0_10px_24px_rgba(15,23,42,0.08)]"
                        onClick={onCancel}
                    >
                        {t('aura delete cancel')}
                    </button>
                    <button
                        type="button"
                        className="rounded-full bg-gradient-to-r from-rose-500 to-pink-500 px-4 py-1.5 text-xs font-semibold text-white shadow-[0_12px_28px_rgba(244,63,94,0.35)]"
                        onClick={onConfirm}
                    >
                        {t('aura delete confirm')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
